import { User } from "../@core/data/users";

export default class Announcement {
  id?: string;
  courseId?: string;
  sectionId?: string;
  lectureId?: string;
  quizId?: string;
  refTitle?: string;
  category?: string; //system / course / guide/marketing

  title?: string;
  description?: string;
  coverUrl?: string;

  priority?: string; //info / success / warning / danger
  startDate?: Date;
  endDate?: Date;
  responseType?: string; //Yes-No, Ok
  responseAction?: string; //callback

  sourceType?: string; //video/images/document
  content?: string; //document
  videoUrl?: string; //video
  imagesUrl?: string[]; //images

  tags?: string[];
  privacy?: boolean;
  status?: number;
  showComments?: boolean;
  newComment?: boolean;

  noViewer?: number;
  noLiked?: number;
  noComment?: number;

  //Moderator
  isReviewed?: boolean;
  isApproved?: boolean;
  approvedOn?: Date;
  approvedBy?: string;
  approvedAuthor?: User;

  //default
  timestamp?: number;
  author?: User;
  createdBy?: string;
  createdOn?: Date;
  updatedBy?: string;
  updatedOn?: Date;
  isDeleted?: boolean;
  isActive?: boolean;
  visibility?: string;
  accessToken?: string;
}
